import { AppIcon } from '@app/components/atm.app-icon';
import { DocumentationStatus } from '@app/data/graphql';
import { homeStrings } from '@app/modules/home/home.strings';
import { Badge } from '@atomic/atm.badge';
import React from 'react';
const strings = homeStrings.documentationStatus;
export function DocumentationStatusBadge(props) {
    if (!props.status) {
        return null;
    }
    const { badgeColor, iconColor, text } = DocumentationStatusBadgeMapping[props.status];
    return (React.createElement(Badge, { color: badgeColor, text: props.small ? text.short : text.full, size: 'small', icon: React.createElement(AppIcon.Card, { size: 'medium', variant: iconColor }) }));
}
const DocumentationStatusBadgeMapping = {
    [DocumentationStatus.Pending]: {
        badgeColor: 'accessory',
        text: strings.Pending,
        iconColor: 'primary',
    },
    [DocumentationStatus.Approved]: {
        badgeColor: 'successLight',
        text: strings.Approved,
        iconColor: 'successDark',
    },
    [DocumentationStatus.Rejected]: {
        badgeColor: 'alertLight',
        text: strings.Rejected,
        iconColor: 'alertDark',
    },
    [DocumentationStatus.ManualAnalysis]: {
        badgeColor: 'warningLight',
        text: strings.ManualAnalysis,
        iconColor: 'warning',
    },
    [DocumentationStatus.Expired]: {
        badgeColor: 'accessory',
        text: strings.Expired,
        iconColor: 'primary',
    },
};
